import React from "react";
import SearchControls from "./src/searchControls";
import AppointmentList from "./src/appointmentList";

const DayliPlanContainer = (): React.JSX.Element => (
  <React.Fragment>
    <SearchControls />
    <AppointmentList />
  </React.Fragment>
);

export default DayliPlanContainer;
